import React from "react";
import { Collapse, Grid } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import SupplierMap from "./supplierMap";

export default function CityMap(props: any) {
  const [openCollapseSupp, setOpenCollapseSupp] = React.useState(false);
  return (
    <>
      <Collapse in={props.openCollapseCity} sx={{ width: "100%" }}>
        <Grid
          className="borderBottomDrawer mbottom13  borderBeforCity textFont13"
          container
          spacing={2}
          item
          xs={12}
          onClick={() => setOpenCollapseSupp((prev: any) => !prev)}
        >
          <Grid item xs={3}>
            <span style={{ color: "#73D9C4" }}>
              &nbsp;شهر {props.city.cityTitle}
            </span>
          </Grid>
          <Grid item xs={7}>
            <span style={{ color: "#fff" }}>
              {" "}
              تعداد:&nbsp;{props.city.totalCount} | مبلغ:{" "}
              {props.city.totalAmount.toLocaleString("fa")} ریال
            </span>
          </Grid>
          <Grid item xs={1} className="centerDrawerMap">
            {openCollapseSupp ? (
              <ArrowDropDownIcon fontSize="large" />
            ) : (
              <ArrowLeftIcon fontSize="large" />
            )}
          </Grid>
        </Grid>
      </Collapse>
      {props.city.suppliers.map((supp: any) => (
        <SupplierMap
          supp={supp}
          openCollapseSupp={openCollapseSupp}
          openCollapseCity={props.openCollapseCity}
          setFlyToLoc={props.setFlyToLoc}
        />
      ))}
    </>
  );
}
